import { withGameContextProvider } from "../../hocs/with-game-context-provider";
import { withLocalizationContextProvider } from "../../hocs/with-localization-context-provider";

import { withCommanderContextProvider } from "./with-commander-context-provider";
import { withRoutes } from "./with-routes";
import { withLocalizedNamespaceContextProvider } from "./with-localized-namespace-context-provider";

import { InboxController } from "./controller";
import { withPollContextProvider } from "../../stores/poll";
import { withInboxRewardsContextProvider } from "../../stores/inboxRewards";
import { withSessionContextProvider } from "../../stores/session";

export const InboxContainer = withLocalizationContextProvider(
    withRoutes(
        withGameContextProvider(
            withCommanderContextProvider(
                withLocalizedNamespaceContextProvider(
                    withSessionContextProvider(
                        withInboxRewardsContextProvider(
                            withPollContextProvider(InboxController),
                        ),
                    ),
                ),
            ),
        ),
    ),
);
